import { useState, useEffect } from "react";
import moment, { Moment } from "moment";

function useIdleSaveDraft(saveDraftFunction: () => void) {

  const idleTimeToSaveDraft = 300; //in seconds

  const [lastUpdatedTime, setLastUpdatedTime] = useState<Moment>(moment());
  
  useEffect(() => {
    let interval = setInterval(() => {
      const currentTime = moment();

      const difference = currentTime.diff(lastUpdatedTime, "seconds");
      if (difference >= idleTimeToSaveDraft) {
        saveDraftFunction();
        setLastUpdatedTime(moment());
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [lastUpdatedTime, saveDraftFunction]);

  useEffect(() => {
    document.body.onclick = () => {
      setLastUpdatedTime(moment());
    };

    return () => {
      document.body.onclick = () => {};
    };
  }, []);

  return { lastUpdatedTime };
}

export default useIdleSaveDraft;
